/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { vappContainer } from '@/application';
import { logger as log } from '@common/logger';
import { OrganizationProfilePageService } from '@pages/OrganizationProfile/services';

const getSrv = () => {
  return vappContainer.get<OrganizationProfilePageService>(
    OrganizationProfilePageService.displayName
  );
};

export const getOrganizationProfile = async (context: any, event: any) => {
  const currentState = 'GET_ORGANIZATION_PROFILE';
  const method = 'getOrganizationProfile';

  // @ts-ignore
  return new Promise(async (resolve, reject) => {
    try {
      log.log('context: ', context, 'event: ', event);
      // console.log("machine",context);
      const srv = getSrv();
      const shelves = await srv.agent.getFeatureProfile({ type: event.type });
      if (shelves) {
        return resolve({
          key: 'RENDER_ORGANIZATION_PROFILE',
          value: {
            ...(shelves || {}),
          },
        });
      } else {
        const msg = 'Page content not found';
        log.error(`error in ${method}, msg: ${msg}`);
        return reject({
          key: 'RENDER_ORGANIZATION_PROFILE_ERROR',
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(`error in ${method}, msg: ${err?.message}`);
      return reject({
        key: 'RENDER_ORGANIZATION_PROFILE_ERROR',
        value: err?.message,
      });
    }
  });
};
